import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ProductService } from '../_services';
import * as productActions from '../_actions/product';

@Injectable({
  providedIn: 'root',
})
export class ProductEffects {
  loadproducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.loadProducts),
      mergeMap(() =>
        this.productService.getProducts().pipe(
          map((products) =>
            productActions.loadProductsSuccess({
              products: products.map((p) => ({ ...p, isSelectable: true })),
            })
          ),
          catchError((error) => of(productActions.loadProductsFailure({ error })))
        )
      )
    )
  );

  addproduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.addProduct),
      mergeMap(({ product }) =>
        this.productService.saveProduct(product).pipe(
          map((savedproduct) => productActions.addProductSuccess({ product: savedproduct })),
          catchError((error) => of(productActions.addProductFailure({ error })))
        )
      )
    )
  );

  updateproduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.updateProduct),
      mergeMap(({ product }) =>
        this.productService.saveProduct(product).pipe(
          map((updatedproduct) => productActions.updateProductSuccess({ product: updatedproduct })),
          catchError((error) => of(productActions.updateProductFailure({ error })))
        )
      )
    )
  );

  deleteproduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.deleteProduct),
      mergeMap(({ id }) =>
        this.productService.deleteProduct(id).pipe(
          map(() => productActions.deleteProductSuccess({ id })),
          catchError((error) => of(productActions.deleteProductFailure({ error })))
        )
      )
    )
  );

  // Fetch single product (fallback when not in store)
  fetchProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.fetchProduct),
      mergeMap(({ productId, isSelectable }) =>
        this.productService.getProduct(productId).pipe(
          map((product) =>
            productActions.fetchProductSuccess({ product, isSelectable: isSelectable ?? true })
          ),
          catchError((error) => of(productActions.fetchProductFailure({ error })))
        )
      )
    )
  );

  // Add product to store after successful fetch
  addProductToStoreAfterLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.fetchProductSuccess),
      map(({ product }) => productActions.addProductSuccess({ product }))
    )
  );

  // Fetch multiple products by IDs (batch fetch)
  fetchProductsByIds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.fetchProductsByIds),
      mergeMap(({ productIds, isSelectable }) =>
        this.productService.getProductsByIds(productIds).pipe(
          map((products) =>
            productActions.fetchProductsByIdsSuccess({
              products: products.map((p) => ({ ...p, isSelectable: isSelectable ?? true })),
            })
          ),
          catchError((error) => {
            console.error(error);
            return of(productActions.fetchProductsByIdsFailure({ error }));
          })
        )
      )
    )
  );

  // Add products to store after successful batch fetch
  addProductsToStoreAfterBatchLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.fetchProductsByIdsSuccess),
      map(({ products }) => productActions.addManyProductsSuccess({ products }))
    )
  );

  constructor(
    private actions$: Actions,
    private productService: ProductService
  ) {}
}
